var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRugbyUnion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M14.5 4.066c-.015 1.94-1.446 5.157-4.351 7.191-2.959 2.072-6.547 2.287-8.345 1.592 5.094.484 11.731-4.123 12.684-8.723l.012-.06zm-9.613-.323c3.692-2.585 8.364-2.28 9.315-.923.042.06.08.126.112.198.013 4.973-7.833 10.555-13.226 9.432a1.403 1.403 0 0 1-.253-.27c-.95-1.357.361-5.852 4.052-8.437z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#509CF2",
    d: "M14.203 2.765c.042.06.079.123.11.19.08 5.009-7.873 10.668-13.29 9.48a1.149 1.149 0 0 1-.258-.26c-.95-1.358.688-5.476 4.4-8.074 3.71-2.599 8.088-2.694 9.038-1.336z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M9.016 9.52c3.102-2.172 5.046-4.746 4.165-6.005-.882-1.26-4.67-1.363-7.77.808-3.102 2.172-4.344 5.797-3.462 7.056.882 1.26 3.966.312 7.067-1.86z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRugbyUnion);
export default __webpack_public_path__ + "static/media/rugby_union.ae31f7062148f4d4a5995cb5ee3aac7c.svg";
export { ForwardRef as ReactComponent };